import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/ads';

const ListAds = () => {
  const filter = {};

  return (
    <ListResource
    {...{
      // searchable: true,
      api,
      sort: { page: 1, location: 1 },
      filter,
      // actions: {
      //   fileImport: { url: '/api/site/banners/files' },
      // },
      cols: [
        { key: 'name', sortable: true, children: 'Name' },
        { key: 'type', sortable: true, children: 'Type' },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
        { key: 'description' },
        { key: 'script' },
      ],
      // ctrls: [
      //   <select
      //     className="custom-select"
      //     key={0}
      //     value={location}
      //     onChange={(e) => setLocation(e.target.value)}
      //   >
      //     <option value="">Select Attribute</option>
      //     {attr.map((a) => (
      //       <option key={a} value={a}>{a}</option>
      //     ))}
      //   </select>,
      // ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListAds;
